"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WidgetClientV2 = void 0;
const tslib_1 = require("tslib");
const authenticated_client_1 = require("./authenticated.client");
class WidgetClientV2 extends authenticated_client_1.AuthenticatedClient {
    create(projectId, dashboardId, payload) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(`/v2/projects/${projectId}/users/me/dashboards/${dashboardId}/widgets`, payload);
            return response.payload;
        });
    }
    getAll(projectId, dashboardId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v2/projects/${projectId}/users/me/dashboards/${dashboardId}/widgets`);
            return response.payload;
        });
    }
    getById(projectId, dashboardId, id) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v2/projects/${projectId}/users/me/dashboards/${dashboardId}/widgets/${id}`);
            return response.payload;
        });
    }
    update(projectId, dashboardId, id, payload) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPut(`/v2/projects/${projectId}/users/me/dashboards/${dashboardId}/widgets/${id}`, payload);
            return response.payload;
        });
    }
    updateMany(projectId, dashboardId, payload) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPut(`/v2/projects/${projectId}/users/me/dashboards/${dashboardId}/widgets`, payload);
            return response.payload;
        });
    }
    delete(projectId, dashboardId, id) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpDelete(`/v2/projects/${projectId}/users/me/dashboards/${dashboardId}/widgets/${id}`);
            return response.payload;
        });
    }
    bulkDelete(projectId, dashboardId, ids) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpDelete(`/v2/projects/${projectId}/users/me/dashboards/${dashboardId}/widgets?` + this.getQueryString({ id: ids }));
            return response.payload;
        });
    }
    uploadCustomWidgetThumbnail(projectId, formData, progress$) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(`/v2/projects/${projectId}/users/me/widget/custom-thumbnail`, formData, {
                onUploadProgress: (progressEvent) => {
                    progress$.next(Math.round((progressEvent.loaded * 100) / progressEvent.total));
                },
            });
            return response.payload;
        });
    }
}
exports.WidgetClientV2 = WidgetClientV2;
//# sourceMappingURL=widget.client.v2.js.map